import KBBHeader from './KBBHeader';

export default KBBHeader;
